import { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [token, setToken] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await apiClient.post("/auth/forgot-password", { email });
            setSubmitted(true);
            if (data.reset_token) setToken(data.reset_token);
            toast.success("If that email is registered, a reset link has been generated.");
        } catch (err) {
            toast.error(formatApiError(err));
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-cream p-8">
            <form onSubmit={submit} className="w-full max-w-md" data-testid="forgot-form">
                <div className="text-xs uppercase tracking-[0.25em] text-walnut-light mb-3">Recover access</div>
                <h2 className="font-serif text-4xl text-ink">Forgot password</h2>
                <p className="text-stone-muted text-sm mt-2">Enter your admin email; we'll generate a reset token.</p>

                <label className="block mt-8">
                    <span className="text-xs uppercase tracking-widest text-stone-muted block mb-2">Email</span>
                    <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-stone-border px-4 py-3 focus:outline-none focus:border-walnut" />
                </label>
                <button data-testid="forgot-submit" className="mt-5 w-full bg-walnut text-cream py-3 text-sm tracking-wider uppercase hover:bg-walnut-dark">Send reset token</button>

                {submitted && token && (
                    <div data-testid="forgot-dev-token" className="mt-6 bg-sand border border-walnut/30 p-4 text-xs">
                        <div className="font-medium text-ink mb-1">Dev mode — email service not configured</div>
                        <div className="break-all text-stone-muted">Token: <code className="text-walnut">{token}</code></div>
                        <Link to={`/admin/reset-password?token=${token}`} className="inline-block mt-3 text-walnut underline">Use this token to reset →</Link>
                    </div>
                )}

                <div className="mt-6 text-xs">
                    <Link to="/admin/login" className="text-stone-muted hover:text-walnut">← Back to sign in</Link>
                </div>
            </form>
        </div>
    );
}
